module.exports = "/static/assets/22c4291ba7654bf25a16d92e827d0a43.gif";